import { render } from "./StepD.vue?vue&type=template&id=04074d2a"
import script from "./StepD.vue?vue&type=script&lang=js"
export * from "./StepD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/signupEntrepreneur/StepD.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04074d2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04074d2a', __exports__)) {
    api.reload('04074d2a', __exports__)
  }
  
  module.hot.accept("./StepD.vue?vue&type=template&id=04074d2a", () => {
    api.rerender('04074d2a', render)
  })

}


export default __exports__